/**
 * ```typescript
 * parseLocationSearchParamsToJSON('a=1&b=2&c=3'); //=> {a: 1, b: 2, c: 3}
 * parseLocationSearchParamsToJSON('?a=1&b=2'); //=> {a: 1, b: 2}
 * parseLocationSearchParamsToJSON(''); //=> {}
 * ```
 */
export function parseLocationSearchParamsToJSON(paramsString?: string): Record<string, any> {
  const result = {};

  if (!paramsString) {
    return result;
  }

  if (paramsString.startsWith('?')) {
    paramsString = paramsString.substr(1);
  }

  paramsString.split('&').forEach(param => {
    const [
      key = '',
      value = '',
    ] = param.split('=');
    result[key] = value;
  });

  return result;
}
